/**
 * Animation duration in ms
 */
const ANIMATION_DURATION = 300;
/**
 * Container width in px
 */
const CONTAINER_WIDTH = 592;
const wrapperTransitionStyles = {
    entering: { opacity: 0, width: '100vw', height: '100vh' },
    entered: { opacity: 1, overflow: 'auto', width: '100vw', height: '100vh' },
    exiting: { opacity: 0, width: '100vw', height: '100vh' },
    exited: { opacity: 0 },
    unmounted: { opacity: 0 },
};
const transitionStyles = {
    entering: { width: 0 },
    entered: { width: `${CONTAINER_WIDTH}px`, overflow: 'auto' },
    exiting: { width: 0 },
    exited: { width: 0 },
    unmounted: { width: 0 },
};

export { ANIMATION_DURATION, CONTAINER_WIDTH, transitionStyles, wrapperTransitionStyles };
